<script lang="ts">
	import CardRounded from '../atoms/CardRounded.svelte';
	import StickerNanoid from '../stickers/StickerNanoid.svelte';

	export let text: string;
	export let title: string | null = null;
	export let img: string | null = null;
	export let sticker: any = null;
	export let link: any = null;
</script>

<CardRounded>
	<div class="flex flex-col items-center justify-center">
		{#if img}
			<div class="w-28 pb-4">
				<img alt="Qrot" src={img} />
			</div>
		{/if}
		{#if title}
			<h3 class="text-xl font-medium pb-2">{title}</h3>
		{/if}
		{#if sticker}
			<StickerNanoid sticker_nanoid={sticker.nanoid} />
		{:else if link}
			<StickerNanoid sticker_nanoid={link.link_nanoid} />
		{/if}
		<p class=" text-center font-light text-sm">
			{text}
		</p>
		<div class="self-stretch">
			<slot />
		</div>
	</div>
</CardRounded>
